__turbopack_context__.v({
  "book-deals": "UJt0bG_book-deals",
  "header-title": "UJt0bG_header-title",
  "headerCopy": "UJt0bG_headerCopy",
  "interest-page-header": "UJt0bG_interest-page-header",
  "loader": "UJt0bG_loader",
  "read-more-button": "UJt0bG_read-more-button",
  "title": "UJt0bG_title",
});
